import React from "react";
import { SRETRADE_REGISTER } from "../mock";
import { TrendingUp, TrendingDown, Search, Bell, Wallet, ArrowUpRight } from "lucide-react";

const MobileApp = () => {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, #1c4d9c 0%, #2f6bc8 60%, #1c4d9c 100%)",
        }}
      />
      {/* Top wave */}
      <svg
        className="absolute top-0 left-0 w-full"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
      >
        <path d="M0,0 L1440,0 L1440,40 C1080,80 720,0 360,40 C200,55 100,30 0,55 Z" fill="white" />
      </svg>
      {/* Background circles */}
      <div className="absolute -right-20 top-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-white/5" />
      <div className="absolute right-10 top-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-white/5" />

      <div className="relative max-w-[1280px] mx-auto px-4 py-24 grid lg:grid-cols-2 gap-12 items-center text-white">
        <div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
            37 yıllık tecrübe ile
          </h2>
          <p className="text-white/90 leading-relaxed mb-7 max-w-lg">
            Sizlere sunduğumuz modern işlem platformu ile Borsa İstanbul Pay ve
            VİOP verilerini takip edebilir, hesabınızdan anlık işlemler
            yapabilirsiniz.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={SRETRADE_REGISTER}
              target="_blank"
              rel="noreferrer"
              className="px-7 py-3 rounded-md bg-[#e23a3a] hover:bg-[#c52d2d] text-white font-semibold transition shadow-sm"
            >
              Hesap Aç
            </a>
          </div>
        </div>

        <div className="relative flex justify-center lg:justify-end">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
};

const stocks = [
  { sym: "GARAN", name: "Garanti BBVA", val: "94.20", chg: 2.15, color: "from-emerald-400 to-emerald-600" },
  { sym: "AKBNK", name: "Akbank", val: "68.45", chg: 1.45, color: "from-rose-400 to-red-500" },
  { sym: "THYAO", name: "Türk Hava Yolları", val: "312.50", chg: -0.85, color: "from-amber-400 to-orange-500" },
  { sym: "ASELS", name: "Aselsan", val: "68.10", chg: 0.92, color: "from-violet-400 to-purple-500" },
];

const PhoneMockup = () => (
  <div className="relative">
    <div className="relative" style={{ transform: "rotate(8deg)" }}>
      <div className="w-[290px] h-[580px] rounded-[44px] bg-slate-900 p-2.5 shadow-2xl border-[3px] border-slate-800">
        <div
          className="w-full h-full rounded-[36px] relative overflow-hidden"
          style={{ background: "linear-gradient(180deg, #0b1226 0%, #0f1830 100%)" }}
        >
          {/* Notch */}
          <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-5 bg-black rounded-full z-30" />

          {/* Status bar */}
          <div className="pt-3 px-5 flex items-center justify-between text-white text-[10px] z-20 relative">
            <span className="font-semibold">9:41</span>
            <span className="flex items-center gap-1 opacity-80">●●●●● 5G ▮</span>
          </div>

          {/* Top: greeting + search */}
          <div className="px-5 pt-3">
            <div className="flex items-center justify-between mb-3">
              <div>
                <p className="text-[10px] text-white/60">Günaydın</p>
                <p className="text-white text-[13px] font-semibold">Yatırımcı 👋</p>
              </div>
              <div className="flex gap-2">
                <div className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center">
                  <Search className="w-3.5 h-3.5 text-white" />
                </div>
                <div className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center relative">
                  <Bell className="w-3.5 h-3.5 text-white" />
                  <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-emerald-400" />
                </div>
              </div>
            </div>

            {/* Portfolio card */}
            <div
              className="rounded-2xl p-4 mb-3 relative overflow-hidden"
              style={{
                background:
                  "linear-gradient(135deg, #4f86d6 0%, #1c4d9c 100%)",
              }}
            >
              <div
                className="absolute -right-4 -top-4 w-20 h-20 rounded-full"
                style={{ background: "radial-gradient(circle, rgba(255,255,255,0.18) 0%, transparent 70%)" }}
              />
              <div className="flex items-center justify-between mb-1">
                <span className="text-white/80 text-[10px] flex items-center gap-1">
                  <Wallet className="w-3 h-3" /> Portföy Değeri
                </span>
                <span className="text-emerald-300 text-[10px] font-bold flex items-center gap-0.5">
                  <ArrowUpRight className="w-3 h-3" /> +2.84%
                </span>
              </div>
              <div className="text-white text-2xl font-bold tracking-tight">
                ₺ 248,520
              </div>
              {/* Mini sparkline */}
              <svg viewBox="0 0 240 30" className="w-full h-7 mt-1">
                <polyline
                  points="0,22 30,18 60,20 90,12 120,16 150,8 180,11 210,5 240,9"
                  fill="none"
                  stroke="#86efac"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>

          {/* Tabs */}
          <div className="px-5 flex items-center gap-1.5 mb-2.5">
            {["Watchlist", "Pay", "VİOP"].map((t, i) => (
              <div
                key={i}
                className={`px-2.5 py-1 rounded-full text-[10px] font-semibold ${
                  i === 0
                    ? "bg-white text-[#0b1226]"
                    : "bg-white/10 text-white/70"
                }`}
              >
                {t}
              </div>
            ))}
          </div>

          {/* Stock list */}
          <div className="px-3">
            {stocks.map((s, i) => (
              <div
                key={i}
                className="flex items-center justify-between px-2 py-2 rounded-xl hover:bg-white/5"
              >
                <div className="flex items-center gap-2.5">
                  <div
                    className={`w-8 h-8 rounded-full bg-gradient-to-br ${s.color} flex items-center justify-center text-white text-[9px] font-bold`}
                  >
                    {s.sym.slice(0, 2)}
                  </div>
                  <div>
                    <div className="text-[11px] font-bold text-white">
                      {s.sym}
                    </div>
                    <div className="text-[9px] text-white/50">{s.name}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[11px] font-semibold text-white">
                    ₺{s.val}
                  </div>
                  <div
                    className={`text-[9px] font-bold flex items-center justify-end gap-0.5 ${
                      s.chg >= 0 ? "text-emerald-400" : "text-rose-400"
                    }`}
                  >
                    {s.chg >= 0 ? (
                      <TrendingUp className="w-2.5 h-2.5" />
                    ) : (
                      <TrendingDown className="w-2.5 h-2.5" />
                    )}
                    {s.chg > 0 ? "+" : ""}
                    {s.chg}%
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom nav */}
          <div className="absolute bottom-0 left-0 right-0 px-5 pb-4">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl py-2.5 px-3 border border-white/10 flex items-center justify-around">
              {[
                { l: "Piyasa", active: true },
                { l: "İşlem", active: false },
                { l: "Portföy", active: false },
                { l: "Profil", active: false },
              ].map((t, i) => (
                <div
                  key={i}
                  className="flex flex-col items-center gap-0.5"
                >
                  <div
                    className={`w-1.5 h-1.5 rounded-full ${
                      t.active ? "bg-white" : "bg-white/0"
                    }`}
                  />
                  <span
                    className={`text-[9px] font-semibold ${
                      t.active ? "text-white" : "text-white/50"
                    }`}
                  >
                    {t.l}
                  </span>
                </div>
              ))}
            </div>
            {/* iOS home indicator */}
            <div className="mx-auto mt-2 w-24 h-1 rounded-full bg-white/30" />
          </div>
        </div>
      </div>
    </div>

    {/* Round badge */}
    <div
      className="absolute -right-6 -bottom-2 w-32 h-32 rounded-full flex items-center justify-center text-white text-[10px] font-bold tracking-wider"
      style={{
        background: "radial-gradient(circle, #2f6bc8 0%, #143a78 100%)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
      }}
    >
      <svg viewBox="0 0 128 128" className="w-full h-full absolute inset-0">
        <defs>
          <path
            id="circle-mob"
            d="M 64,64 m -48,0 a 48,48 0 1,1 96,0 a 48,48 0 1,1 -96,0"
          />
        </defs>
        <text fill="white" fontSize="11" fontWeight="700" letterSpacing="2">
          <textPath href="#circle-mob">
            PİYASALARDAKİ GÖZÜNÜZ · PİYASALARDAKİ ·
          </textPath>
        </text>
      </svg>
      <span className="font-bold italic text-base">Acar</span>
    </div>
  </div>
);

export default MobileApp;
